import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllTransaction } from "../../Actions/adminActions";
import { Container, Row, Col } from "react-bootstrap";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import CopyComponent from "../../Component/CopyComponent/CopyComponent";
import moment from "moment";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import { HiDownload } from "react-icons/hi";
import "./With.css";
import debounce from "lodash.debounce";
import Popup from "reactjs-popup";
import apiCall from "../../API/API";

const PriRejectedWith = () => {
  const { paymentRequests } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState("none");
  const [companyDetails, setCompanyDetails] = useState();

  const getCompanyDetails = async () => {
    try {
      const res = await apiCall("GET", "/get-company-info");
      console.log("company details", res);
      setCompanyDetails(res?.data?.company_info);
    } catch (error) {
      console.error(error.message);
    }
  };

  var x = 0;
  useEffect(() => {
    if (x == 0) {
      getCompanyDetails();
      x++;
    }
  }, []);
  const [search, setsearch] = useState({
    source: "withdrawal",
    status: "2",
    amount: "",
    username: "",
    search: "",
    startDate: "",
    endDate: "",
    uid: "",
    // token_symbol: "",
  });

  // useEffect(() => {
  //   if (companyDetails?.tokens?.[0]?.tokenSymbol) {
  //     setsearch((prev) => ({
  //       ...prev,
  //       token_symbol: companyDetails.tokens[0].tokenSymbol,
  //     }));
  //   }
  // }, [companyDetails]);

  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchWithdraw = useCallback(
    debounce((params) => {
      dispatch(fetchAllTransaction(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    fetchWithdraw({
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
      ...(startDate && endDate ? { startDate, endDate } : {}),
    });
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }

    dispatch(fetchAllTransaction(queryParams));
  };

  const resetFilter = () => {
    setsearch({
      source: "withdrawal",
      status: "2",
      amount: "",
      username: "",
      search: "",
      startDate: "",
      endDate: "",
      uid: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);

    dispatch(
      fetchAllTransaction({
        page: 1,
        limit: 20,
        source: "withdrawal",
        status: "2",
      })
    );
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: 20,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchWithdraw(queryParams);
  }, [dispatch, currentPage, limitFilter, search, startDate, endDate]);

  useEffect(() => {
    setTotalPages(paymentRequests?.totalPages);
  }, [paymentRequests]);

  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <h4 className="m-0">Rejected Principal Withdrawal</h4>
          {/* <div>
            <select
              name="token_symbol"
              value={search.token_symbol}
              onChange={handleChange}
              style={{ borderRadius: "5px", width: "100%" }}
            >
              {companyDetails?.tokens
                ?.filter((token) => token.enabled === 1)
                ?.map((token, i) => (
                  <option value={token?.tokenSymbol}>
                    {token?.tokenSymbol}
                  </option>
                ))}
            </select>
          </div>*/}
        </div>
        <Row id="filterRow">
          <span className="filterL">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
              <div className="align-content-center">
                Total Credited Amount : {paymentRequests?.creditSum}
              </div>
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search By Name, Username"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  name="amount"
                  placeholder="Search By Amount"
                  value={search.amount}
                  onChange={handleChange}
                />
              </div>
            </Col>
            {/*<Col lg="2" md="4">
              <div>
              
              <input type="text" name='username' placeholder="Search By UserName" value={search.username} onChange={handleChange} />
               </div>
            </Col>*/}
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name=""
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>

        <div id="directIncomeDiv">
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Uid</th>
                    <th>Account Details</th>
                    <th>Requested Amount</th>
                    {/* <th>Admin Fee</th> */}
                    {/* <th>Repurchase Wallet</th> */}
                    {/* <th>Withdrawal Amount</th> */}
                    {/* <th>Utility Bonus</th> */}
                    <th>Hash Code</th>
                    <th>Status</th>
                    {/* <th>Proof</th> */}
                    {/* <th>Transaction id</th> */}
                    <th>Date</th>
                  </tr>
                  {paymentRequests?.data?.map((row, index) => (
                    <tr key={index}>
                      {/* <td>
                <input
                  type="checkbox"
                  checked={selectedRows.includes(index)}
                  onChange={() => toggleSelectRow(index, row.tx_Id)}
                  className="checkbox-input"
                  id={`row-${index}`}
                />
                <label htmlFor={`row-${index}`} className="checkbox-label">
                  <span
                    className={`custom-checkbox ${
                      selectedRows.includes(index) ? "checked" : ""
                    }`}
                  />
                </label>
              </td> */}
                      <td>{index + 1 + limitFilter * (currentPage - 1)}</td>
                      <td>{row.name}</td>
                      <td>{row.username}</td>
                      <td>{row?.uid}</td>
                      <td>
                        {" "}
                        <div className="keyValue">
                          {" "}
                          {row?.account?.address}
                          <CopyComponent value={row?.account?.address} />
                        </div>{" "}
                      </td>
                      <td>{parseFloat(row?.amount).toFixed(2)}</td>
                      {/* <td>{parseFloat(row.tx_charge).toFixed(2)}</td> */}
                      {/* <td>{row.Re_purchase_wallet}</td> */}
                      {/* <td>{parseFloat(row.withdrawal_amount).toFixed(2)}</td> */}
                      <td>
                        {row.tx_hash === "manual approval" ? (
                          "manual approval"
                        ) : (
                          <a
                            href={`https://bscscan.com/tx/${row.tx_hash}`}
                            target="_blank"
                          >
                            {row.tx_hash}
                          </a>
                        )}
                      </td>
                      {row.status == 0 ? (
                        <td>Pending</td>
                      ) : row.status == 1 ? (
                        <td>Approved</td>
                      ) : (
                        <td>Rejected</td>
                      )}

                      <td>{moment(row?.createdAt).format("lll")}</td>
                      {/* <td style={{ textAlign: "center" }}>
                        <Popup
                          trigger={
                            <button className="block-btn">View Proof</button>
                          }
                          modal
                          closeOnDocumentClick
                        >
                          {(close) => (
                            <div className="popup-content">
                              <button className="close-btn" onClick={close}>
                                &times;
                              </button>
                              <img
                                src={row.proofUrl}
                                alt="proof"
                                className="popImg"
                              />
                              <button
                                className="download-btn"
                                onClick={() => {
                                  const link = document.createElement("a");
                                  link.href = row.proofUrl;
                                  link.download = "proof.jpg";
                                  link.click();
                                }}
                              >
                                <HiDownload />
                              </button>
                            </div>
                          )}
                        </Popup>
                      </td> */}
                      {/* <td>{row.reqest_tx_Id}</td> */}
                      {/* <td>
                        {moment(row?.createdAt).format(
                          "DD-MM-YYYY   &   HH:mm"
                        )}
                      </td> */}
                    </tr>
                  ))}
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default PriRejectedWith;
